
<div class="timeline" #screen>

  <ul>
    @for (item of timeLines; track item) {
      <li [ngClass]="item.class">
        <div class="info" [ngClass]="{'noActive': !item.active}">
          @if (item.icon && item.iconPosition === 'rigth-pos') {
            <div>
              <img [src]="item.icon">
            </div>
          }
          @if (item.canDelete && item.iconPosition  === 'left-pos') {
            <div>
              @if (item.active) {
                <i class="material-icons" style="color: white;" (click)="disactive(item)">
                  block
                </i>
              }
              @if (!item.active) {
                <i class="material-icons" style="color: white;" (click)="active(item)">
                  reply
                </i>
              }
            </div>
          }
          <div>
            <em>{{item.date | date}}</em>
            <strong>{{item.name}}</strong>
          </div>
          @if (item.icon && item.iconPosition === 'left-pos') {
            <div>
              <img [src]="item.icon ">
            </div>
          }
          @if (item.canDelete && item.iconPosition === 'rigth-pos') {
            <div>
              @if (item.active) {
                <i class="material-icons" style="color: white;" (click)="disactive(item)">
                  block
                </i>
              }
              @if (!item.active) {
                <i class="material-icons" style="color: white;" (click)="active(item)">
                  reply
                </i>
              }
            </div>
          }
        </div>
      </li>
    }
  </ul>
  <!--<div class="circle"></div>-->
</div>


<div [hidden]="true" id="download">
  <img #canvas>
  <a #downloadLink></a>
</div>
